export default "__VITE_ASSET__CpuZc8Wa__"